var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69231 11.7692C9.69231 14.4458 7.52266 16.6154 4.84615 16.6154C2.16965 16.6154 0 14.4458 0 11.7692C0 9.09275 2.16965 6.9231 4.84615 6.9231C7.52266 6.9231 9.69231 9.09275 9.69231 11.7692Z",
    fill: "#E72649"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1544 8.30771C12.1603 8.30771 11.2367 8.60951 10.4684 9.12317C10.8477 9.92905 11.0775 10.8193 11.0775 11.7692C11.0775 13.4501 10.4045 14.9692 9.32324 16.0892C10.2093 17.2441 11.587 18.0001 13.1544 18.0001C15.8309 18.0001 18.0006 15.8304 18.0006 13.1539C18.0006 10.4774 15.8309 8.30775 13.1544 8.30775V8.30771Z",
    fill: "#E72649"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15361 5.53846H5.53822C5.53822 3.87692 4.7878 2.40096 3.62465 1.38462H4.84592C8.32415 1.38462 11.2595 3.7315 12.1666 6.92308H13.5942C12.6524 2.96031 9.09257 0 4.84615 0H0V1.38462C2.29019 1.38462 4.15385 3.24827 4.15385 5.53846H4.15361Z",
    fill: "#E72649"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlot);
export default __webpack_public_path__ + "static/media/slot.4af52494a2a7384af07e4bb1d0069722.svg";
export { ForwardRef as ReactComponent };